<template>
<!--  用户信息-->
  <div class="profile view-box">
    <navBan title="个人信息"></navBan>

    <ul class="cell-box">
      <li class="cell-item cell-item-large">
        <div class="cell-title">
          <span class="title-text">头像</span>
          <p class="sub-title">支持jpg、png，大小不超过5mb</p>
        </div>
        <div @click="editAvatar" class="cell-value">
          <div class="avatar-box" :style="userInfo.avatarStyle">
          </div>
          <img class="icon" src="../../assets/images/mobile/rightarrow.svg" alt="">
        </div>
      </li>

      <li class="cell-item">
        <div class="cell-title">
          <span class="title-text">昵称</span>
        </div>
        <div @click="router.push({ name: 'nickName', query: { nickName: userInfo.nickName } })" class="cell-value">
          <span class="value-text">{{ userInfo.nickName }}</span>
          <img class="icon" src="../../assets/images/mobile/rightarrow.svg" alt="">
        </div>
      </li>
      <li class="cell-item">
        <div class="cell-title">
          <span class="title-text">性别</span>
        </div>
        <div @click="modifySex" class="cell-value">
          <span class="value-text">{{ userInfo.sexDesc }}</span>
          <img class="icon" src="../../assets/images/mobile/rightarrow.svg" alt="">
        </div>
      </li>
      <li class="cell-item">
        <div class="cell-title">
          <span class="title-text">UID</span>
        </div>
        <div class="cell-value">
          <span class="value-text">{{ userInfo.uid }}</span>
        </div>
      </li>
    </ul>

    <!-- 修改头像的弹窗-->
    <div @click="visible = false" v-if="visible" class="modal-mask">
      <div class="modal-body">
        <div class="avatar-box">
          <img class="avatar" :src="userInfo.avatar" alt="">
        </div>
        <div class="btn-box">
          <div @click="triggerInput" class="upload-btn">
            更换头像
            <input id="uploadInput" class="upload-input" @change="upload"  type="file" accept="image/*">
          </div>
        </div>
      </div>
    </div>

    <!-- 选择性别的弹窗-->
    <div v-if="sexVisible" class="modal-mask">
      <div class="modal-body-sex">
        <div class="btn-box">
          <div class="btn" @click="sexVisible = false">取消</div>
          <div class="btn btn-confirm" @click="confirm">确定</div>
        </div>
        <ul class="sex-list">
          <li
            @click="selectSex(item, index)"
            v-for="(item, index) of sexList"
            :key="index"
            class="sex-item"
            :class="{ 'sex-item-active': selectedIndex===item.value }"
          >{{item.label}}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
import navBan from '@/components/navBan';
import { onBeforeMount, ref, reactive, computed } from 'vue';
import { useRouter } from 'vue-router';
import { getUserInfo, onSubmit, uploadAvatar, triggerInput } from '@/utils/setup/userInfo';
import { useStore } from 'vuex';

const store = useStore();
const userInfo = computed(() => store.state.userInfo);

let visible = ref(false);
let sexVisible = ref(false);
let selectedIndex = ref(0);
let sexList = reactive([
  { label: '男', value: 1 },
  { label: '女', value: 2 },
  { label: '保密', value: 0 }
]);

const router = useRouter();

onBeforeMount(() => {
  getUserInfo();
});

/** 打开性别的弹窗 */
function modifySex () {
  selectedIndex.value = userInfo.sex;
  sexVisible.value = true;
}
/** 选择性别 */
function selectSex (item, index) {
  selectedIndex.value = item.value;
}
/** 确定选择性别 */
function confirm () {
  userInfo.sex = selectedIndex.value;
  sexVisible.value = false;

  onSubmit(true, (data) => {
    data.sex = userInfo.sex;
  });
}
/** 打开头像弹窗 */
function editAvatar () {
  visible.value = true;
}

async function upload (event) {
  await uploadAvatar(event);
  visible.value = false;
}
</script>

<style lang="scss">
.profile {
  padding: 16px;
  .cell-box .cell-item .cell-title .title-text {
    margin-left: 0;
  }
  .cell-item {
    .sub-title {
      margin-top: 8px;
      color: rgba(171, 178, 189, 1);
      font-family: PingFang SC;
      font-size: 12px;
      line-height: 12px;
    }
    .avatar-box {
      display: inline-block;
      width: 48px;
      height: 48px;
      border-radius: 50%;
      overflow: hidden;
      .avatar {
        height: 100%;
        width: 100%;
      }
    }
  }
  .cell-item-large {
    height: 80px;
  }
  .modal-mask {
    padding: 0;
    .modal-body {
      padding: 0;
      background: rgba(9, 38, 72, 0.4);
      .avatar-box {
        width: 100%;
        height: 360px;
        .avatar {
          width: 100%;
        }
      }
      .btn-box {
        padding-top: 100px;
        padding-bottom: 74px;
      }
    }
  }
  .upload-btn {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 120px;
    height: 44px;
    border-radius: 22px;
    overflow: hidden;
    border: 1px solid rgba(255, 255, 255, 1);
    background-color: transparent;
    color: rgba(255, 255, 255, 1);
    font-family: PingFang SC;
    font-size: 14px;
  }
  .upload-input {
    position: absolute;
    top: -50px;
    left: -130px;
  }

  .modal-body-sex {
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: #fff;
    width: 100%;
    padding-bottom: 34px;
    .btn-box {
      padding: 16px 24px;
      display: flex;
      justify-content: space-between;
      //box-shadow: 0px -0.5px rgba(234, 234, 234, 1) inset;
      border-bottom: 1px solid #E9EDF3;
      .btn {
        color: rgba(134, 143, 156, 1);
        font-family: PingFang SC;
        font-size: 16px;
      }
      .btn-confirm {
        color: rgba(68, 129, 235, 1);
      }
    }
    .sex-list {
      padding: 24px;
      .sex-item {
        height: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 6px;
      }
      .sex-item:active,
      .sex-item-active {
        background: rgba(244, 247, 251, 1);
      }
      .sex-item +.sex-item {
        margin-top: 16px;
      }
    }
  }
}
</style>
